import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoubleArrowIcon(props: IconProps) {
    return <Icon {...props} iconKey={"double_arrow"}/>
}
